import { z } from 'zod'

export const trainerXanoCoreExceptionResponseSchema = z.record(z.unknown())
export type TrainerXanoCoreExceptionResponse = z.infer<typeof trainerXanoCoreExceptionResponseSchema>
